import React, { useState, useEffect } from "react";
import { FaChevronDown } from "react-icons/fa";
import { useParams } from "react-router-dom";
import axiosConfig from "../Service/axiosConfig";
import DataTable from "react-data-table-component";
import "../Pages/Styles/CourseInfo.css";

const EventInfo = () => {
  const { eventId } = useParams();
  const [eventData, setEventData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [RowPerPage, setRowPerPage] = useState(30);
  const [loading, setLoading] = useState(true); // To show loading state

  // Custom styles for DataTable
  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "#f3f4f6",
        borderBottomWidth: "1px",
      },
    },
    headCells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
      },
    },
    cells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
      },
    },
  };
  // Fetch Event details
  useEffect(() => {
    const fetchEventDetails = async () => {
      try {
        const response = await axiosConfig.get(`/accounts/event/${eventId}/`);
        setEventData(response.data);
      } catch (error) {
        console.error("Error fetching course details:", error);
      }
    };
    fetchEventDetails();
  }, [eventId]);

  return (
    <div className="course-info">
      <div className="course-info-grid">
        {eventData?.id ? (
          <div key={eventData.id} className="course-card">
            <img src={eventData.thumbnail?.image} alt={eventData.event_title} />
            <div className="course-content">
              <h3>{eventData.event_title}</h3>
              <p>{eventData.event_description}</p>
              <div className="course-details">
                <div className="detail">
                  <span className="label">Start Date Time:</span>
                  <span className="value">{eventData.start_datetime}</span>
                </div>
                <div className="detail">
                  <span className="label">End Date Time:</span>
                  <span className="value">{eventData.end_datetime}</span>
                </div>
                <div className="detail">
                  <span className="label"> Event Duration:</span>
                  <span className="value">{eventData.event_duration}</span>
                </div>
                <div className="detail">
                  <span className="label">Registration Fee:</span>
                  <span className="value">
                    {eventData.registration_fee || "Free"}
                  </span>
                </div>
                <div className="detail">
                  <span className="label">Event Type:</span>
                  <span className="value">{eventData.event_type}</span>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <p>No Event data available</p>
        )}
      </div>
    </div>
  );
};

export { EventInfo };
